import React from "react";
import { MapPin } from "lucide-react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";

export function AddressForm({ userData, handleUserDataChange, errors }) {
  return (
    <div className="mb-10">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-800 to-blue-600 flex items-center justify-center shadow-md">
          <MapPin className="w-5 h-5 text-white" />
        </div>

        <h2 className="text-2xl font-semibold text-slate-800">Endereço</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="md:col-span-2">
          <Label htmlFor="logradouro" className="text-sm font-medium text-slate-700">
            Logradouro
          </Label>

          <Input
            id="logradouro"
            value={userData.logradouro}
            onChange={(e) => handleUserDataChange("logradouro", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.logradouro
                ? "border-red-400 focus:border-red-600"
                : "border-slate-200 focus:border-blue-800"
            }`}
          />

          {errors.logradouro && (
            <p className="mt-1 text-xs text-red-600">{errors.logradouro}</p>
          )}
        </div>

        <div>
          <Label htmlFor="numero" className="text-sm font-medium text-slate-700">
            Número
          </Label>

          <Input
            id="numero"
            value={userData.numero}
            onChange={(e) => handleUserDataChange("numero", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.numero
                ? "border-red-400 focus:border-red-600"
                : "border-slate-200 focus:border-blue-800"
            }`}
          />

          {errors.numero && (
            <p className="mt-1 text-xs text-red-600">{errors.numero}</p>
          )}
        </div>

        <div>
          <Label htmlFor="bairro" className="text-sm font-medium text-slate-700">
            Bairro
          </Label>

          <Input
            id="bairro"
            value={userData.bairro}
            onChange={(e) => handleUserDataChange("bairro", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.bairro
                ? "border-red-400 focus:border-red-600"
                : "border-slate-200 focus:border-blue-800"
            }`}
          />

          {errors.bairro && (
            <p className="mt-1 text-xs text-red-600">{errors.bairro}</p>
          )}
        </div>

        <div>
          <Label htmlFor="complemento" className="text-sm font-medium text-slate-700">
            Complemento
          </Label>

          <Input
            id="complemento"
            value={userData.complemento}
            onChange={(e) => handleUserDataChange("complemento", e.target.value)}
            className="mt-2 border-2 border-slate-200 focus:border-blue-800 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20"
          />
        </div>

        <div>
          <Label htmlFor="cep" className="text-sm font-medium text-slate-700">
            CEP
          </Label>

          <Input
            id="cep"
            value={userData.cep}
            onChange={(e) => handleUserDataChange("cep", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.cep
                ? "border-red-400 focus:border-red-600"
                : "border-slate-200 focus:border-blue-800"
            }`}
          />

          {errors.cep && <p className="mt-1 text-xs text-red-600">{errors.cep}</p>}
        </div>

        <div>
          <Label htmlFor="cidade" className="text-sm font-medium text-slate-700">
            Cidade
          </Label>

          <Input
            id="cidade"
            value={userData.cidade}
            onChange={(e) => handleUserDataChange("cidade", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.cidade
                ? "border-red-400 focus:border-red-600"
                : "border-slate-200 focus:border-blue-800"
            }`}
          />

          {errors.cidade && (
            <p className="mt-1 text-xs text-red-600">{errors.cidade}</p>
          )}
        </div>

        <div>
          <Label htmlFor="estado" className="text-sm font-medium text-slate-700">
            Estado
          </Label>

          <Input
            id="estado"
            value={userData.estado}
            onChange={(e) =>
              handleUserDataChange(
                "estado",
                (e.target.value || "").toUpperCase().slice(0, 2)
              )
            }
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.estado
                ? "border-red-400 focus:border-red-600"
                : "border-slate-200 focus:border-blue-800"
            }`}
          />

          {errors.estado && (
            <p className="mt-1 text-xs text-red-600">{errors.estado}</p>
          )}
        </div>
      </div>
    </div>
  );
}
